"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOffsets = exports.thresholdsByPixels = void 0;
function thresholdsByPixels() {
    var arrayThresholds = [];
    for (var i = 0; i <= 1.0; i += 0.01) {
        arrayThresholds.push(i);
    }
    return arrayThresholds;
}
exports.thresholdsByPixels = thresholdsByPixels;
function getOffsets(optionsOffsets) {
    var offsetsString = optionsOffsets || '0px';
    var offsets = offsetsString.split(/\s+/).map(function (offset) {
        var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(offset);
        if (!parts)
            throw new Error('rootMargin must be specified in pixels or percent');
        return { value: parseFloat(parts[1]), unit: parts[2] };
    });
    // Handles shorthand.
    offsets[1] = offsets[1] || offsets[0];
    offsets[2] = offsets[2] || offsets[0];
    offsets[3] = offsets[3] || offsets[1];
    return offsets;
}
exports.getOffsets = getOffsets;
